import React, {
  useEffect,
  useState,
} from 'react';
import { DateTime, Info } from 'luxon';

import addColDurations from './utils/addColDurations';
import dateIncrements from './utils/dateIncrements';

const GanttDates = ({
  colSize,
  colCount,
  colOffset,
  dateMode,
  dateAlignMode,
}) => {
  const [dates, setDates] = useState({
    top: [],
    bottom: [],
  });
  const [dateDisplays, setDateDisplays] = useState([]);

  useEffect(() => {
    const now = DateTime.local();
    const start = addColDurations(now, dateMode, colOffset);
    
    const { bottomType, topType, quantity } = dateIncrements[dateMode];
    
    const currBottomItems = [];
    const currTopItems = [];
    let topItemColStart = 0;
    let topItemColCount = 0;
    let prevDate;
    
    const months = Info.months();
    const resolveDate = (date, type) => {
      if (!date) return;
      
      const item = date[type];
      
      let formattedItem;
      if (type === 'month') {
        formattedItem = months[item - 1];
        
        if (item === 1) formattedItem += ` ${date['year']}`;
      } else {
        formattedItem = item;
      }
      
      return formattedItem;
    }
    
    for (let i = 0; i < colCount; i++) {
      const currDate = addColDurations(start, dateMode, i);
      const currBottomItem = currDate[bottomType];
      
      if (currBottomItem <= quantity) {
        currTopItems.push({ 
          item: resolveDate(prevDate, topType),
          colStart: topItemColStart,
          colCount: topItemColCount,
        });
        
        prevDate = currDate;
      
        topItemColStart += topItemColCount;
        topItemColCount = 0;
      }
      topItemColCount++;
      
      currBottomItems.push(currBottomItem);
    }
    
    currTopItems.push({ 
      item: resolveDate(prevDate, topType),
      colStart: topItemColStart,
      colCount: topItemColCount,
    });

    setDates({
      top: currTopItems,
      bottom: currBottomItems,
    });
  }, [colCount, colOffset, colSize, dateMode]);

  useEffect(() => {
    const topDateDisplays = dates.top.map((date, i) => ( 
      <svg
        key={`gantt-dates-top-${i}`}
        height={colSize} 
        width={colSize * date.colCount}
        x={(colSize * date.colStart + 14)}
        y="0"
      >
        <svg
          style={{overflow: 'visible'}}
        >
          <text
            y="50%" 
            dominantBaseline="middle" 
            textAnchor="left"
          >
            {date.item}
          </text>
        </svg>
      </svg>
    ));
  
    const bottomDateDisplays = dates.bottom.map((date, i) => (
      <svg
        key={`gantt-dates-bottom-${i}`}
        height={colSize} 
        width={colSize}
        x={colSize * i}
        y={colSize}
      >
        <text
          x="50%" 
          y="50%" 
          dominantBaseline="middle" 
          textAnchor="middle"
        >
          {date}
        </text>
      </svg>
    ));
    
    setDateDisplays(
      <React.Fragment>
        {topDateDisplays}
        {bottomDateDisplays}
      </React.Fragment>
    );
  }, [dates, colSize]);

  return (
    <svg 
      style={{position: 'absolute'}}
      x="0"
      y="0"
      height={colSize * 2} 
      width={colSize * dates.bottom.length}
    >
      {dateDisplays}
    </svg>
  );
};

export default GanttDates;
